const CREATEONEPAGEWEBSITE = 'twineApp/onePageWebsite/CREATEONEPAGEWEBSITE';
const CREATEONEPAGEWEBSITE_SUCCESS =
  'twineApp/onePageWebsite/CREATEONEPAGEWEBSITE_SUCCESS';
const CREATEONEPAGEWEBSITE_FAIL =
  'twineApp/onePageWebsite/CREATEONEPAGEWEBSITE_FAIL';
const UPDATEONEPAGEWEBSITELINKS =
  'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITELINKS';
const UPDATEONEPAGEWEBSITELINKS_SUCCESS =
  'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITELINKS_SUCCESS';
const UPDATEONEPAGEWEBSITELINKS_FAIL =
  'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITELINKS_FAIL';
const UPDATEONEPAGEWEBSITE = 'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITE';
const UPDATEONEPAGEWEBSITE_SUCCESS =
  'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITE_SUCCESS';
const UPDATEONEPAGEWEBSITE_FAIL =
  'twineApp/onePageWebsite/UPDATEONEPAGEWEBSITE_FAIL';

const initialState = {
  created: false,
  creating: false,
  updating: false,
  updated: false,
  updatingLinksErrors: null,
  updatingWebsiteErrors: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case CREATEONEPAGEWEBSITE:
      return {
        ...state,
        creating: true,
        created: false,
      };

    case CREATEONEPAGEWEBSITE_SUCCESS:
      return {
        ...state,
        creating: false,
        created: true,
      };

    case CREATEONEPAGEWEBSITE_FAIL:
      return {
        ...state,
        creating: false,
        created: false,
      };

    case UPDATEONEPAGEWEBSITELINKS:
      return {
        ...state,
        updating: true,
        updated: false,
      };

    case UPDATEONEPAGEWEBSITELINKS_SUCCESS:
      return {
        ...state,
        updating: false,
        updated: true,
        updatingLinksErrors: null,
      };

    case UPDATEONEPAGEWEBSITELINKS_FAIL:
      return {
        ...state,
        updating: false,
        updated: false,
        updatingLinksErrors: action.error.errors,
      };

    case UPDATEONEPAGEWEBSITE:
      return {
        ...state,
        updating: true,
      };

    case UPDATEONEPAGEWEBSITE_SUCCESS:
      return {
        ...state,
        updating: false,
        updated: true,
        updatingWebsiteErrors: null,
      };

    case UPDATEONEPAGEWEBSITE_FAIL:
      return {
        ...state,
        updating: false,
        updated: false,
        updatingWebsiteErrors: action.error.errors,
      };

    default:
      return state;
  }
}

export function createOnePageWebsite(userId) {
  return {
    types: [
      CREATEONEPAGEWEBSITE,
      CREATEONEPAGEWEBSITE_SUCCESS,
      CREATEONEPAGEWEBSITE_FAIL,
    ],
    promise: (client) =>
      client.post(`/users/${userId}/website`, {
        data: { theme: 'default' },
      }),
  };
}

export function updateOnePageWebsiteLinks(userId, links) {
  return {
    types: [
      UPDATEONEPAGEWEBSITELINKS,
      UPDATEONEPAGEWEBSITELINKS_SUCCESS,
      UPDATEONEPAGEWEBSITELINKS_FAIL,
    ],
    promise: (client) =>
      client.post(`/users/${userId}/website/links`, {
        data: { links: links },
      }),
    ignoreError: true,
  };
}

export function updateOnePageWebsite(userId, data) {
  return {
    types: [
      UPDATEONEPAGEWEBSITE,
      UPDATEONEPAGEWEBSITE_SUCCESS,
      UPDATEONEPAGEWEBSITE_FAIL,
    ],
    promise: (client) =>
      client.patch(`/users/${userId}/website`, {
        data: data,
      }),
    ignoreError: true,
  };
}
